<div class="div-table">
  <table mat-table [dataSource]="dataSource" matSort>
    @if (showFilter) {
      <ng-container matColumnDef="filter">
        <th
          mat-header-cell
          *matHeaderCellDef
          [attr.colspan]="displayedColumns.length"
          class="table-header"
        >
          <tds-text-field
            type="text"
            size="md"
            state="default"
            label="search"
            no-min-width
            placeholder="Pesquisar"
            tds-aria-label="Table search"
            [(ngModel)]="searchValue"
            (keyup)="applyFilter()"
          >
            <span slot="prefix">
              <tds-icon name="search"></tds-icon>
            </span>
            <span slot="suffix">
              <tds-icon name="cross" (click)="clearFilter()"></tds-icon>
            </span>
          </tds-text-field>
        </th>
        <tr mat-header-row *matHeaderRowDef="['filter']"></tr>
      </ng-container>
    }

    @if (hasSelector) {
      <ng-container matColumnDef="select" style="width: 10px">
        <th mat-header-cell *matHeaderCellDef class="table-checkbox-header">
          <mat-checkbox
            (change)="$event ? toggleAllRows() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
            [aria-label]="checkboxLabel()"
          >
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row" class="table-checkbox-content">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? toggleRow(row) : null"
            [checked]="selection.isSelected(row)"
            [aria-label]="checkboxLabel(row)"
          >
          </mat-checkbox>
        </td>
      </ng-container>
    }

    @for (item of headers; track $index) {
      <ng-container matColumnDef="{{ item.value }}">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          class="table-header"
        >
          {{ item.label }}
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          class="{{
            typeof getNestedValue(element, item.value) === 'boolean'
              ? 'table-checkbox-content'
              : 'table-content'
          }}"
        >
          @let value = getNestedValue(element, item.value);

          @if (typeof value === "boolean") {
            <mat-checkbox [checked]="value" disabled="disabled"> </mat-checkbox>
          } @else if (item.pipe === "datetime") {
            {{ value | utcToLocal: "dd/MM/yyyy HH:mm:ss" }}
          } @else if (item.pipe === "date") {
            {{ value | utcToLocal: "dd/MM/yyyy HH:mm:ss" }}
          } @else {
            {{ value }}
          }
        </td>
      </ng-container>
    }

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="table-header">Ações</th>
      <td mat-cell *matCellDef="let row" class="table-action">
        <div class="actions">
          @if (hasVisualize) {
            <tds-icon
              name="search"
              title="Visualizar"
              (click)="visualize(row)"
            ></tds-icon>
          }
          @if (hasEdit) {
            <tds-icon
              name="edit"
              title="Editar"
              (click)="edit(row)"
              class="icon-size"
            ></tds-icon>
          }
          @if (hasDelete) {
            <tds-icon
              name="trash"
              title="Excluir"
              (click)="exclude(row)"
            ></tds-icon>
          }
          @if (hasRemove) {
            <tds-icon
              name="cross"
              title="Remover"
              (click)="remove(row)"
            ></tds-icon>
          }
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
@if (hasPaginator) {
  <mat-paginator
    [pageSizeOptions]="[5, 10, 25, 100, 1000, 5000]"
    aria-label="Selecione a quantidade de itens à exibir"
    [pageSize]="10"
  ></mat-paginator>
}
